<template>
  <div>
    <!-- ══ KPI Visitas (4 tarjetas) ══════════════════════════════════════════ -->
    <cartas-personalizadas :cartas="datosVisitas" />

    <!-- ══ KPI Ingresos (4 tarjetas) ═════════════════════════════════════════ -->
    <cartas-personalizadas :cartas="datosPagos" class="mt-3" />

    <!-- ══ Gráfica ingresos del mes + ingresos anuales ═══════════════════════ -->
    <v-row class="mt-2">
      <v-col cols="12" sm="6">
        <v-card rounded="xl" class="elevation-2 pa-3">
          <div class="text-caption text--secondary font-weight-bold mb-1 text-uppercase">
            <v-icon x-small class="mr-1" color="orange">mdi-chart-line</v-icon>
            Ingresos del mes — Diarios
          </div>
          <sparkline-component
            :etiquetas="etiquetasPagosMes"
            :valores="valoresPagosMes"
            :color="'orange darken-1'"
            titulo="" subtitulo=""
          />
        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card rounded="xl" class="elevation-2 pa-3">
          <div class="text-caption text--secondary font-weight-bold mb-1 text-uppercase">
            <v-icon x-small class="mr-1" color="blue darken-1">mdi-chart-bar</v-icon>
            Ingresos anuales — Por mes
          </div>
          <sparkline-component
            :etiquetas="etiquetasPagosMeses"
            :valores="valoresPagosMeses"
            :color="'blue darken-1'"
            titulo="" subtitulo=""
          />
        </v-card>
      </v-col>
    </v-row>

    <!-- ══ Estado + Accesos rápidos ══════════════════════════════════════════ -->
    <v-row class="mt-2" dense>

      <!-- Activos -->
      <v-col cols="6" sm="4" md="2">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/miembros" hover>
          <v-icon color="success" size="30" class="mb-1">mdi-account-check</v-icon>
          <div class="text-h5 font-weight-black success--text">{{ miembrosActivos }}</div>
          <div class="text-caption grey--text">Activos</div>
          <v-progress-linear :value="pctActivos" color="success" rounded height="3" class="mt-2" />
        </v-card>
      </v-col>

      <!-- Vencidos -->
      <v-col cols="6" sm="4" md="2">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/miembros" hover>
          <v-icon color="error" size="30" class="mb-1">mdi-account-off</v-icon>
          <div class="text-h5 font-weight-black error--text">{{ miembrosVencidos }}</div>
          <div class="text-caption grey--text">Vencidos</div>
        </v-card>
      </v-col>

      <!-- Alertas -->
      <v-col cols="6" sm="4" md="2">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/alertas" hover>
          <v-badge :content="alertasUrgentes" :value="alertasUrgentes > 0" color="error" overlap>
            <v-icon color="orange" size="30" class="mb-1">mdi-bell-alert</v-icon>
          </v-badge>
          <div class="text-h5 font-weight-black orange--text">{{ alertasUrgentes }}</div>
          <div class="text-caption grey--text">Alertas</div>
        </v-card>
      </v-col>

      <!-- Escáner QR -->
      <v-col cols="6" sm="4" md="2">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/escanear-qr" hover color="primary">
          <v-icon color="white" size="30" class="mb-1">mdi-qrcode-scan</v-icon>
          <div class="text-subtitle-2 font-weight-bold white--text">Escáner</div>
          <div class="text-caption white--text">QR de entrada</div>
        </v-card>
      </v-col>

      <!-- Registrar visita manual -->
      <v-col cols="6" sm="4" md="2" v-if="esAdmin || esRecepcionista">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/registrar-visita" hover>
          <v-icon color="indigo" size="30" class="mb-1">mdi-home-account</v-icon>
          <div class="text-subtitle-2 font-weight-bold">Registrar</div>
          <div class="text-caption grey--text">Visita manual</div>
        </v-card>
      </v-col>

      <!-- Matricular -->
      <v-col cols="6" sm="4" md="2" v-if="esAdmin || esRecepcionista">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/nuevo-miembro" hover>
          <v-icon color="primary" size="30" class="mb-1">mdi-account-plus</v-icon>
          <div class="text-subtitle-2 font-weight-bold">Matricular</div>
          <div class="text-caption grey--text">Nuevo miembro</div>
        </v-card>
      </v-col>

      <!-- Pagos (solo admin) -->
      <v-col cols="6" sm="4" md="2" v-if="esAdmin">
        <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/pagos" hover>
          <v-icon color="teal" size="30" class="mb-1">mdi-currency-usd</v-icon>
          <div class="text-subtitle-2 font-weight-bold">Pagos</div>
          <div class="text-caption grey--text">Ver reporte</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- ══ Métricas avanzadas solo admin ════════════════════════════════════= -->
    <template v-if="esAdmin && metricasCargadas">

      <!-- KPIs de gestión -->
      <v-row class="mt-2" dense>
        <!-- Retención -->
        <v-col cols="6" md="3">
          <v-card rounded="xl" class="elevation-2 pa-3 text-center">
            <v-progress-circular
              :value="retencion.porcentajeActivos"
              :color="retencion.porcentajeActivos >= 70 ? 'success' : retencion.porcentajeActivos >= 50 ? 'orange' : 'error'"
              size="64" width="6" rotate="-90"
            >
              <span class="text-subtitle-1 font-weight-bold">{{ retencion.porcentajeActivos }}%</span>
            </v-progress-circular>
            <div class="text-caption font-weight-bold mt-1">Retención</div>
            <div class="text-caption text--secondary">{{ retencion.total }} miembros total</div>
          </v-card>
        </v-col>

        <!-- Nuevos -->
        <v-col cols="6" md="3">
          <v-card rounded="xl" class="elevation-2 pa-3 text-center">
            <v-icon :color="retencion.crecimiento >= 0 ? 'success' : 'error'" size="36" class="mb-1">
              {{ retencion.crecimiento >= 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}
            </v-icon>
            <div class="text-h5 font-weight-black" :class="retencion.crecimiento >= 0 ? 'success--text' : 'error--text'">
              {{ retencion.nuevosEsteMes }}
            </div>
            <div class="text-caption font-weight-bold">Nuevos este mes</div>
            <v-chip x-small :color="retencion.crecimiento >= 0 ? 'success' : 'error'" dark class="mt-1">
              {{ retencion.crecimiento >= 0 ? '+' : '' }}{{ retencion.crecimiento }}% vs anterior
            </v-chip>
          </v-card>
        </v-col>

        <!-- Próximos a vencer -->
        <v-col cols="6" md="3">
          <v-card rounded="xl" class="elevation-2 pa-3 text-center" to="/alertas" hover>
            <v-icon color="orange darken-2" size="36" class="mb-1">mdi-calendar-clock</v-icon>
            <div class="text-h5 font-weight-black orange--text">{{ proximosVencer.length }}</div>
            <div class="text-caption font-weight-bold">Vencen en 7 días</div>
          </v-card>
        </v-col>

        <!-- Proyección -->
        <v-col cols="6" md="3">
          <v-card rounded="xl" class="elevation-2 pa-3 text-center">
            <v-icon color="blue darken-2" size="36" class="mb-1">mdi-chart-line</v-icon>
            <div class="text-h6 font-weight-black blue--text">{{ moneda }}{{ proyeccionIngresos }}</div>
            <div class="text-caption font-weight-bold">Proyección mes</div>
            <div class="text-caption text--secondary">prom. últimos 3 meses</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Distribución de membresías (chips) -->
      <v-card rounded="xl" class="elevation-2 mt-2 pa-3" v-if="distribucionMembresias.length">
        <div class="text-caption font-weight-bold text--secondary mb-2 text-uppercase">
          <v-icon x-small class="mr-1">mdi-chart-donut</v-icon>Planes activos
        </div>
        <div class="d-flex flex-wrap gap-1">
          <v-chip
            v-for="(item, i) in distribucionMembresias" :key="i"
            small class="mr-1 mb-1"
            :color="coloresPie[i % coloresPie.length]" dark
          >
            {{ item.nombre }}: {{ item.total }}
          </v-chip>
        </div>
      </v-card>

      <!-- Tabla próximos a vencer -->
      <v-card rounded="xl" class="elevation-2 mt-2" v-if="proximosVencer.length">
        <v-card-title class="text-subtitle-2 font-weight-bold py-2 px-4">
          <v-icon color="orange" small class="mr-1">mdi-calendar-alert</v-icon>
          Membresías por vencer (7 días)
          <v-spacer />
          <v-chip x-small color="orange darken-1" dark>{{ proximosVencer.length }}</v-chip>
        </v-card-title>
        <v-divider />
        <v-list dense class="py-0">
          <v-list-item v-for="m in proximosVencer" :key="m.id" :to="'/editar-miembro/' + m.id" dense>
            <v-list-item-content>
              <v-list-item-title class="text-body-2">{{ m.nombre }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">{{ m.membresia }} · {{ m.fechaFin }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip x-small :color="m.diasRestantes <= 2 ? 'error' : 'orange'" dark>
                {{ m.diasRestantes === 0 ? 'Hoy' : m.diasRestantes + 'd' }}
              </v-chip>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </template>

    <v-overlay :value="cargando">
      <v-progress-circular size="64" indeterminate />
    </v-overlay>
  </div>
</template>

<script>
import HttpService from '../Servicios/HttpService'
import Utiles from '../Servicios/Utiles'
import CartasPersonalizadas from './Dialogos/CartasPersonalizadas.vue'
import SparklineComponent from './Dialogos/SparklineComponent.vue'

export default {
  name: 'InicioComponent',
  components: { CartasPersonalizadas, SparklineComponent },

  data() {
    return {
      cargando: false,
      moneda: localStorage.getItem('monedaGimnasio') || '₡',
      rolActual: localStorage.getItem('rolUsuario') || 'recepcionista',
      miembrosActivos: 0,
      miembrosVencidos: 0,
      alertasUrgentes: 0,
      datosVisitas: [],
      datosPagos: [],
      etiquetasPagosMes: [], valoresPagosMes: [],
      etiquetasPagosMeses: [], valoresPagosMeses: [],
      // Métricas avanzadas
      metricasCargadas: false,
      retencion: { porcentajeActivos: 0, total: 0, nuevosEsteMes: 0, crecimiento: 0 },
      proximosVencer: [],
      distribucionMembresias: [],
      ingresos12: [],
      coloresPie: ['#1565c0','#6a1b9a','#00838f','#e65100','#2e7d32','#c62828','#f9a825','#283593'],
    }
  },

  computed: {
    esAdmin()        { return this.rolActual === 'admin' },
    esRecepcionista(){ return this.rolActual === 'recepcionista' },
    pctActivos() {
      var total = this.miembrosActivos + this.miembrosVencidos
      return total > 0 ? Math.round((this.miembrosActivos / total) * 100) : 0
    },
    proyeccionIngresos() {
      if (!this.ingresos12.length) return '0.00'
      var arr  = this.ingresos12.slice(-3)
      var prom = arr.reduce(function(s, i) { return s + parseFloat(i.total || 0) }, 0) / arr.length
      return prom.toLocaleString('es-CR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },

  mounted() {
    this.obtenerDatos()
    if (this.rolActual === 'admin') this.obtenerMetricas()
  },

  methods: {
    obtenerDatos() {
      var self = this
      this.cargando = true
      HttpService.obtenerConDatos({ metodo: 'obtener' }, 'inicio.php').then(function(r) {
        if (!r) return
        self.crearCartas(r.datosVisitas, r.datosPagos)
        self.miembrosActivos  = r.miembrosActivos  || 0
        self.miembrosVencidos = r.miembrosVencidos || 0
        var pm = Utiles.cambiarNumeroANombreMes(r.pagosMeses)
        self.etiquetasPagosMes    = Utiles.obtenerClaves(r.pagosMes)
        self.valoresPagosMes      = Utiles.obtenerValoresPagos(r.pagosMes)
        self.etiquetasPagosMeses  = Utiles.obtenerClaves(pm)
        self.valoresPagosMeses    = Utiles.obtenerValoresPagos(pm)
      })
      HttpService.obtenerAlertas().then(function(a) {
        if (a && a.resumen) self.alertasUrgentes = a.resumen.urgente || 0
        self.cargando = false
      }).catch(function() { self.cargando = false })
    },

    obtenerMetricas() {
      var self = this
      HttpService.obtenerConDatos({ metodo: 'metricas', dias: 7 }, 'inicio.php').then(function(r) {
        if (!r) return
        self.retencion              = r.retencion              || self.retencion
        self.proximosVencer         = r.proximosVencer         || []
        self.distribucionMembresias = r.distribucionMembresias || []
        self.ingresos12             = r.ingresos12meses        || []
        self.metricasCargadas       = true
      })
    },

    crearCartas(visitas, pagos) {
      var m = this.moneda
      this.datosVisitas = [
        { color: 'purple darken-1', icono: 'mdi-calendar-star', nombre: 'Total visitas', total: visitas.totalVisitas },
        { color: 'pink darken-1',   icono: 'mdi-calendar',      nombre: 'Hoy',           total: visitas.visitasHoy },
        { color: 'red darken-1',    icono: 'mdi-calendar-range', nombre: 'Esta semana',   total: visitas.visitasSemana },
        { color: 'indigo darken-1', icono: 'mdi-calendar-month', nombre: 'Este mes',      total: visitas.visitasMes },
      ]
      this.datosPagos = [
        { color: 'blue darken-1',   icono: 'mdi-currency-usd',  nombre: 'Ingresos total', total: m + (pagos.totalPagos || '0') },
        { color: 'teal darken-1',   icono: 'mdi-calendar',      nombre: 'Hoy',            total: m + (pagos.pagosHoy || '0') },
        { color: 'green darken-1',  icono: 'mdi-calendar-range', nombre: 'Esta semana',   total: m + (pagos.pagosSemana || '0') },
        { color: 'orange darken-1', icono: 'mdi-calendar-month', nombre: 'Este mes',      total: m + (pagos.pagosMes || '0') },
      ]
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/InicioComponent.vue